import TestModel from '../../../models/test'

const FrpTestModel = TestModel.extend({
    correct() {
        const test = this.currentQuestion()

        // if the multiplication chart test do the default
        if (!test) {
            return TestModel.prototype.correct.apply(this, arguments)
        }

        const tag = test.question_list[0].tag

        switch (tag) {
            case 'f':
                this.set({
                    score: this.get('score') + 1,
                    count: this.get('count') + 1,
                    fluency_score: this.get('fluency_score') + 1,
                    fluency_count: this.get('fluency_count') + 1
                })
                break
            case 'r':
                this.set({
                    score: this.get('score') + 1,
                    count: this.get('count') + 1,
                    reasoning_score: this.get('reasoning_score') + 1,
                    reasoning_count: this.get('reasoning_count') + 1
                })
                break
            case 'p':
                this.set({
                    score: this.get('score') + 1,
                    count: this.get('count') + 1,
                    problem_score: this.get('problem_score') + 1,
                    problem_count: this.get('problem_count') + 1
                })
                break
        }
    },
    incorrect() {
        const test = this.currentQuestion()

        // if the multiplication chart test do the default
        if (!test) {
            return TestModel.prototype.incorrect.apply(this, arguments)
        }

        const tag = test.question_list[0].tag

        switch (tag) {
            case 'f':
                this.set({
                    count: this.get('count') + 1,
                    fluency_count: this.get('fluency_count') + 1
                })
                break
            case 'r':
                this.set({
                    count: this.get('count') + 1,
                    reasoning_count: this.get('reasoning_count') + 1
                })
                break
            case 'p':
                this.set({
                    count: this.get('count') + 1,
                    problem_count: this.get('problem_count') + 1
                })
                break
        }
    },
})

export default FrpTestModel
